<template>
  <div class="login" @click="useAuthV2 ? loginByAuthV2() : onFBLogin()"></div>
</template>

<script>
import { ameDo } from "@/api";

export default {
  name: 'FacebookLogin',
  data () {
    const urlParams = JSON.parse(window.localStorage.getItem('sdkParams') || '{}')
    const useAuthV2 = urlParams.gid === 'dc.global.prod'
    return {
      userInfo: {},
      isRepeat: false,
      useAuthV2
    }
  },
  methods: {
    onFBLogin() {
      const _this = this
      this.$utils.log('pc_login_action', {
        login_action: 'click_facebook'
      })
      // 检测FB登录状态
      window.FB.getLoginStatus(function(statusRes) { // Called after the JS SDK has been initialized.
        console.log('statusRes======', statusRes)
        if (statusRes.status === 'connected') { // 已登录
          _this.getInfo(statusRes.authResponse)
          // Has logged into your webpage and Facebook.
        } else { // 未登录进行登录
          window.FB.login(function(loginRes) {
            console.log('loginRes====', loginRes)
            if (loginRes.status === 'connected') {
              // Logged into your webpage and Facebook.
              _this.getInfo(loginRes.authResponse)
            } else {
              _this.$msg.success(_this.$t('login_fail_2'))
              window.FB.logout()
              // The person is not logged into your webpage or we are unable to tell.
            }
          }, { scope: 'public_profile,email' })
        }
      })
    },
    getInfo (authRes) {
      const _this = this
      window.FB.api('/me/permissions', function(permsResponse) {
          console.log("用户授权的权限：", permsResponse)
      })
      window.FB.api('/me', { fields: 'id,name,email' }, function(profileRes) {
        console.log(profileRes)
        if (!profileRes.id) {
          window.FB.logout()
          if (!_this.isRepeat) {
            _this.isRepeat = true
            setTimeout(() => {
              _this.onFBLogin()
            }, 300);
            return
          }
          _this.$msg.success(_this.$t('login_fail_2'))
          return
        }
        console.log('authRes=======', JSON.stringify(authRes))
        console.log('profileRes=======', JSON.stringify(profileRes))
        _this.isRepeat = false
        _this.userInfo = {
          id: profileRes.id || '',
          name: profileRes.name,
          email: profileRes.email,
          token: authRes.accessToken,
          type: _this.$ENUM.SOCIAL_MAP.FACEBOOK,
          expire: authRes.expiresIn
        }
        _this.login()
      })
    },
    login () {
      this.$emit("success", { ...this.userInfo })
    },

    loginByAuthV2() {
      if (window.__insertedLink && window.__insertedLink.click) {
        window.__insertedLink.click()
        document.body.removeChild(window.__insertedLink)
        return null
      }
      // https://www.facebook.com/v18.0/dialog/oauth?client_id=1411045516218795&redirect_uri=https://store-funplusid-stage.funplus.com/oauthFPX&scope=email&response_type=token
      const urlParams = JSON.parse(window.localStorage.getItem('sdkParams') || '{}')
      const clientId = this.$ENUM.FACEBOOK_ACCOUNT_MAP[urlParams.gid];
      const redirectUri = encodeURIComponent(window.location.origin + location.pathname);
      // const redirectUri = encodeURIComponent('https://store-funplusid-stage.funplus.com/oauthFPX');
      const scope = 'email';
      const responseType = 'token';
      const version = 'v18.0';
      const state = '7aF9qR2tXy'

      const path = `https://www.facebook.com/${version}/dialog/oauth?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&response_type=${responseType}&state=${state}`;
      // console.log(path)
      window.location.href = path;
    },
    checkUrlAuthV2() {
      const urlParams = new URLSearchParams(window.location.hash.substring(1))
      if (urlParams.get('access_token') && urlParams.get('state') === '7aF9qR2tXy') {
        ameDo({
          p0:'web',
          p1:8,
          p2:1067,
          p3:'api',
          g : 'dc.global.prod',
          s : 'facebook',
          c : urlParams.get('access_token'),
          e : urlParams.get('expires_in'),
        })
            .then(profileRes => {
              this.userInfo = {
                id: profileRes.id || '',
                name: profileRes.name,
                email: profileRes.email,
                token: urlParams.get('access_token'),
                type: this.$ENUM.SOCIAL_MAP.FACEBOOK,
                expire: urlParams.get('expires_in')
              }
              this.login()
            })

      }
    },
    addLinkToBody() {
      const urlParams = JSON.parse(window.localStorage.getItem('sdkParams') || '{}')
      const clientId = this.$ENUM.FACEBOOK_ACCOUNT_MAP[urlParams.gid];
      const redirectUri = encodeURIComponent(window.location.origin + location.pathname);
      // const redirectUri = encodeURIComponent('https://store-funplusid-stage.funplus.com/oauthFPX');
      const scope = 'email';
      const responseType = 'token';
      const version = 'v18.0';
      const state = '7aF9qR2tXy'
      const url = `https://www.facebook.com/${version}/dialog/oauth?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&response_type=${responseType}&state=${state}`;

      const link = document.createElement('a');
      link.href = url;
      link.target = '_self'; // 改为本页跳转
      link.style.display = 'none'; // 隐藏链接
      document.body.appendChild(link);
      window.__insertedLink = link;
      // link.click(); // 模拟点击
      // document.body.removeChild(link); // 移除链接
    }
  },
  mounted() {
    if (this.useAuthV2) this.checkUrlAuthV2()
    if (this.useAuthV2) this.addLinkToBody()
  }
}
</script>

<style lang='less' scoped >
.login {
  width: 31px;
  height: 31px;
  background: url(~@img/icon_facebook.png) center center no-repeat;
  background-size: 100% 100%;
}

</style>
